module.exports = "/static/assets/00eae4b48844a30b2f6926525e0ccdea.png";